import { useContext } from 'react';
import { DeleteModal, ModalContext } from 'dash-ui';

const DeleteSaleTeamModal = ({
  onDeleteSaleTeamClick,
}: {
  onDeleteSaleTeamClick: (index: number) => void;
}) => {
  const { payload } = useContext(ModalContext);

  const onSubmit = async () => {
    await onDeleteSaleTeamClick(payload);
  };

  return (
    <DeleteModal
      entity="Sale Team"
      name={payload?.name}
      modalName="DeleteSaleTeamModal"
      onClick={onSubmit}
      colorVariation="danger"
    />
  );
};

export default DeleteSaleTeamModal;
